import { legacyConfigToTree } from '@/features/order/order-form/lib/trigger-condition-migrate'
import type { ConditionNode } from '@/features/order/order-form/lib/trigger-condition-model'
import type { OrderFormCollapsibleConfig } from '@/state/order'

/**
 * Resolve the active trigger condition tree from collapsible config. The
 * structured `entryConditionTreeJson` is authoritative; falls back to the legacy
 * flat config so triggers saved before the tree model still load. Returns null
 * when nothing is configured. This is the single resolution path shared by the
 * submit handler, the header badge, and submit-button validation, so all three
 * agree on what "the trigger" is.
 */
export function resolveConditionTree(
  config: OrderFormCollapsibleConfig | null | undefined
): ConditionNode | null {
  if (!config) return null
  if (config.entryConditionTreeJson) {
    try {
      return JSON.parse(config.entryConditionTreeJson) as ConditionNode
    } catch {
      // Unparseable tree → fall back to the legacy flat config below.
    }
  }
  return legacyConfigToTree(config)
}
